import React from 'react';
import { Route, Switch, useRouteMatch } from 'react-router-dom';
import { TableStateProvider } from './tableState';
import TablePage from './TablePage';
import MessageDetail from './MessageDetail/MessageDetail';
import CombinedStats from './CombinedStats/CombinedStats';

// The message table at /dashboard/analytics-v2, a message's detail page at
// /dashboard/analytics-v2/message/:messageId, and the combined stats page for
// the selected messages at /dashboard/analytics-v2/stats. The table state
// lives in the provider, which stays mounted on all three routes.
const AnalyticsV2 = () => {
  const route = useRouteMatch();

  return (
    <TableStateProvider>
      <Switch>
        <Route exact path={route.path}>
          <TablePage />
        </Route>
        <Route path={`${route.path}/stats`}>
          <CombinedStats tablePath={route.url} />
        </Route>
        {/* Keyed by message, so another message starts with the default
            date range, channel and metrics. */}
        <Route
          path={`${route.path}/message/:messageId`}
          render={({ match }) => (
            <MessageDetail key={match.params.messageId} tablePath={route.url} />
          )}
        />
      </Switch>
    </TableStateProvider>
  );
};

export default AnalyticsV2;
